var productionMode = false;
const urlStart = 'https://mpm-tms-dash.qtrust.id';

export default {productionMode , urlStart};
